module.exports = __webpack_public_path__ + "img/formsKreis.c4cd6833.svg";